<template>
  <input
    v-mask="'###'"
    :value="value"
    class="field-input__inner form__input input-cost-custom"
    autocomplete="new-password"
    :placeholder="placeholder"
    inputmode="numeric"
    @blur="$emit('blur')"
    @input="onInput"
  >
</template>
<script>
export default {
  name: 'InputQuantity',
  props: {
    placeholder: {
      type: String,
      default: 'Количество',
    },
    value: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    onInput(e) {
      this.$emit('input', e.target.value);
    },
  },
};
</script>

<style lang="scss">
.input-quantity {
  position: relative;
  width: 100%;
  input {
    padding: 12px 24px;
    min-height: 60px;
    height: 60px;
  }
  .input-quantity__icon {
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #9FB3C3;
  }
}
</style>
